import React, { useState, useEffect } from 'react';
import { GENERATING_MESSAGES, SAVING_MESSAGES } from '../../utils/constants';

const LoadingScreen = ({ type = 'generating' }) => {
  const [messageIndex, setMessageIndex] = useState(0);

  // Select appropriate messages based on type
  const messages = type === 'saving' ? SAVING_MESSAGES : GENERATING_MESSAGES;
  const subtitle = type === 'saving'
    ? 'Preparing your photo for sharing...'
    : 'Please wait while AI transforms your photo';
  const icon = type === 'saving' ? '☁️' : '✨';

  useEffect(() => {
    const interval = setInterval(() => {
      setMessageIndex((prev) => (prev + 1) % messages.length);
    }, 2000);

    return () => clearInterval(interval);
  }, [messages.length]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex flex-col items-center justify-center px-8">
      <div className="text-center space-y-12">
        {/* Animated Spinner */}
        <div className="relative w-48 h-48 mx-auto">
          <div className="absolute inset-0 border-8 border-[#e5181e]/30 rounded-full"></div>
          <div className="absolute inset-0 border-8 border-transparent border-t-[#e5181e] border-r-red-600 rounded-full animate-spin"></div>
          <div className="absolute inset-4 border-8 border-transparent border-t-red-600 border-r-[#e5181e] rounded-full animate-spin-slow"></div>

          {/* Center Icon */}
          <div className="absolute inset-0 flex items-center justify-center">
            <span className="text-7xl animate-pulse">{icon}</span>
          </div>
        </div>

        {/* Loading Messages */}
        <div className="space-y-4">
          <h2 className="text-4xl font-bold text-white animate-pulse">
            {messages[messageIndex]}
          </h2>
          <p className="text-2xl text-gray-200">
            {subtitle}
          </p>
        </div>

        {/* Progress Dots */}
        <div className="flex justify-center gap-3">
          {[0, 1, 2].map((i) => (
            <div
              key={i}
              className="w-4 h-4 bg-[#e5181e] rounded-full animate-bounce"
              style={{ animationDelay: `${i * 0.15}s` }}
            ></div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
